export function LoadingIndicator() {
  return <span className="sb-nav-spinner" role="status" aria-label="Loading" />;
}
